import styled, { css } from 'styled-components';
import tw from 'tailwind.macro';
import { H4 } from '../../Typographies/Title';

export const PanelWrapperStyle = css`
  ${tw`px-medium2`}
`;

export const PanelWrapper = styled.div`
  ${tw`px-medium2`}
`;

export const PanelScrollableWrapper = styled(PanelWrapper)`
  ${tw`max-h-full overflow-y-auto`}
`;

export const PanelContainer = styled.div<{
  withCTA?: boolean;
  withFunnelMobileHeader?: boolean;
  desktopBreakpoint?: number;
}>`
  ${tw`w-full h-full bg-white rounded-tl-30 rounded-tr-30 pt-medium  overflow-hidden flex flex-col
`}

  ${({ desktopBreakpoint }) =>
    css`
      @media (min-width: ${desktopBreakpoint}px) {
        ${tw`rounded-30 pb-medium2`}
      }
    `}

  ${({ withCTA }) => withCTA && tw`md:pb-0`}
  ${({ desktopBreakpoint, withFunnelMobileHeader }) =>
    withFunnelMobileHeader &&
    css`
      ${tw`rounded-tl-none rounded-tr-none  pt-0 bg-grey-200`}
      @media (min-width: ${desktopBreakpoint}px) {
        ${tw`bg-white pt-medium`}
      }
    `}
`;

export const PanelHeader = styled(PanelWrapper)`
  ${tw`flex mb-medium items-center`}
  gap:var(--size-medium);
  min-height: 50px;
`;

export const PanelTitle = styled(H4)`
  ${tw`py-small
    md:text-title-medium md:leading-title-medium
  `}
  flex:1;
`;

export const PanelImage = styled.img`
  width: 40px;
`;

export const PanelCloseButton = styled.button`
  ${tw`p-0`}
`;

export const PanelContent = styled.div`
  ${tw`h-full flex flex-col overflow-auto`}
`;
